<template>
  <p class="login-item">
    <span
      ref="refPasswordTooltip"
      class="password-input-parent ico-tooltip"
      :data-tooltip="Common.getMessage('MTCL2070', [])"
      data-tooltip-position="top"
    >
      <img
        v-show="passwordFocused && modelValue && !passwordShow"
        class="icon"
        src="@/assets/images/TDSCM/passwordEye.png"
        @mousedown.prevent="changePasswordShow"
      />
      <img
        v-show="passwordFocused && modelValue && passwordShow"
        class="icon"
        src="@/assets/images/TDSCM/passwordEye_show.png"
        @mousedown.prevent="changePasswordShow"
      />
      <input
        ref="refInputArea"
        :type="passwordShow ? 'text' : 'password'"
        @focusin="onFocusIn"
        @focusout="onFocusOut"
        :tabindex="tabindex"
        :maxlength="maxLength"
        :value="modelValue"
        :class="passwordClass"
        v-bind="$attrs"
        class="pass-input"
        @input="inputValue"
        :disabled="disabled"
      />
    </span>
  </p>
</template>
<script setup>
import {
  defineEmits,
  defineProps,
  defineExpose,
  watch,
  ref,
  computed,
} from "vue";
import Common from "@/util/common.js";
import { useKeyModifier } from "@vueuse/core";
const props = defineProps({
  modelValue: {
    required: true,
  },
  tabindex: {
    default: 0,
  },
  hasError: {
    default: false,
  },
  inputClass: {
    default: "frm-text",
  },
  disabled: {
    required: false,
    default: false,
  },
  maxLength: {
    default: 50,
  },
});

const passwordClass = computed(() => {
  return `${props.inputClass} ${props.hasError ? "error" : ""}`;
});

const emit = defineEmits(["update:modelValue"]);
const inputValue = (e) => {
  const value = e.target.value;
  emit("update:modelValue", value);
};
// CapsLock ON/OFF
const capsLockOn = useKeyModifier("CapsLock");

const refInputArea = ref(null);
const refPasswordTooltip = ref(null);
watch(
  () => capsLockOn.value,
  (newVal) => {
    if (newVal && document.activeElement === refInputArea.value) {
      Common.showTooltip({
        currentTarget: refPasswordTooltip.value,
      });
    } else if (!newVal) {
      Common.hideTooltip();
    }
  }
);
// パスワード Focus 状態
const passwordFocused = ref(false);
// パスワード表示フラグ
const passwordShow = ref(false);
const onFocusIn = () => {
  if (capsLockOn.value) {
    Common.showTooltip({
      currentTarget: refPasswordTooltip.value,
    });
  } else {
    Common.hideTooltip();
  }
  $("#password").focus();
  passwordFocused.value = true;
};
const onFocusOut = () => {
  Common.hideTooltip();
  passwordFocused.value = false;
  passwordShow.value = false;
};

// focus
const focus = () => {
  refInputArea.value.focus();
};
defineExpose({
  focus,
});

let backup = "";
watch(
  () => props.disabled,
  (val) => {
    if (val) {
      backup = props.modelValue;
      emit("update:modelValue", "");
    } else {
      emit("update:modelValue", backup);
    }
  }
);

const changePasswordShow = (e)=>{
  // e.preventDefault();
  passwordShow.value = !passwordShow.value;
}
</script>

<style scoped>
.pass-input {
  padding-right: 30px;
}
</style>
